import React from "react";
import { Typography, Paper, Grid, LinearProgress, Box } from "@mui/material";

import { ReactComponent as Shield } from "./icons/rewardShield.svg";
import { ReactComponent as SmallCoin } from "./icons/smallCoin.svg";

const CoinLevels = ({ data = {} }) => {
  const { coins = 0, level = 0, toNextLevel = 0, levelRange = 0, totalEarnedCoins = 0 } = data;
  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: "#FF6A14",
        mb: 2,
        mt: 3.75,
        minHeight: 60,
      }}
    >
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Grid item>
            <Box component={Shield} sx={{ mx: 2, my: 2 }} />
          </Grid>
          <Grid item xs zeroMinWidth>
            <Typography variant="h5" sx={{ color: "#ffffff", fontSize: 20, fontWeight: 600, mt: 0 }}>
              Level {level}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={((levelRange - toNextLevel) / levelRange) * 100}
              sx={{
                height: { xs: 8, sm: 12 },
                borderRadius: 24,
                backgroundColor: "#DB5305",
                mb: 0.5,
                mt: 0.375,
                width: "80%",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "#FDEFE7",
                  borderRadius: 24,
                },
              }}
            />
            <Typography variant="body1" sx={{ textAlign: "left", fontSize: 10, color: "white", mt: 1.125 }}>
              {toNextLevel} COINS FOR NEXT LEVEL
            </Typography>
          </Grid>

          <Grid item>
            <Typography
              variant="h5"
              sx={{
                fontSize: 36,
                fontWeight: "bold",
                color: "#FFFFFF",
                fontFamily: "Montserrat, sans-serif",
                mr: 2,
              }}
            >
              <Box component={SmallCoin} sx={{ mr: 0.5, mb: 1.25 }} />
              {totalEarnedCoins}
            </Typography>
            <Typography variant="body1" sx={{ fontSize: 10, color: "white", textAlign: "right", mr: 2, mt: -0.625, fontWeight: 600, ml: 2.5 }}>
              TOTAL COINS EARNED
            </Typography>
          </Grid>
          <Grid item sx={{ ml: 3.75, display: { xs: 'none', md: 'block' } }}>
            <Typography
              variant="h5"
              sx={{
                fontSize: 36,
                fontWeight: "bold",
                color: "#FFFFFF",
                fontFamily: "Montserrat, sans-serif",
                mr: 2,
              }}
            >
              <Box component={SmallCoin} sx={{ mr: 0.5, mb: 1.25 }} />
              {coins}
            </Typography>
            <Typography variant="body1" sx={{ fontSize: 10, color: "white", textAlign: "right", mr: 2, mt: -0.625, fontWeight: 600, ml: 2.5 }}>
              CURRENT COINS
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    );
}

export default CoinLevels;
